import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import CareerImg from "./assets/img/CareerImg.jpg";
import ContactInfo from "./assets/img/ContactInfo.jpg";

const AboutUs = () => {
  return (
    <>
      <Header></Header>
      <div className="mainContent aboutUsWrap">
        <div className="aboutBannerWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h2>About Us</h2>
                <p>Travel More, Worry Less.</p>
              </div>
            </div>
          </div>
        </div>
        <div className="aboutInfo">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10">
                <p>
                  At Travasco, our mission is simple: to take the stress out of
                  travel and help you focus on what truly matters – creating
                  unforgettable memories. We believe that planning your next
                  adventure should be exciting, not overwhelming. That’s why
                  we’ve built a seamless, customer-focused service designed to
                  handle the details, so you don’t have to.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="companyOverviewWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="dataWrap">
                  <h2>Why Choose Travasco?</h2>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-3">
                <div className="itemWrap">
                  <h2>Personalized Service</h2>
                  <p>
                    Your journey is unique, and so are your needs. Our dedicated
                    team of travel experts is here to offer personalized advice
                    and guidance every step of the way, ensuring your trip is
                    perfectly tailored to you.
                  </p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="itemWrap">
                  <h2>Effortless Booking</h2>
                  <p>
                    With our easy-to-use platform, booking your entire trip –
                    from flights and hotels to activities and excursions – is
                    just a few clicks away. We make the process simple, quick,
                    and convenient.
                  </p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="itemWrap">
                  <h2>Customized Travel Solutions</h2>
                  <p>
                    Whether you’re traveling solo, planning a romantic getaway,
                    or organizing a family vacation, we craft travel experiences
                    that reflect your individual preferences and interests.
                  </p>
                </div>
              </div>
              <div className="col-md-3">
                <div className="itemWrap">
                  <h2>Reliable Support</h2>
                  <p>
                    Our commitment to you doesn’t end once you book. Our
                    friendly support team is available around the clock to
                    assist you before, during, and after your trip. We’re always
                    just a call or email away.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="ourServiceWrap">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-8">
                <div className="titleWrap">
                  <h2>Our Commitment to You</h2>
                  <p>
                    At Travasco, we go beyond just bookings. From your first
                    visit to our site until you return home, our priority is to
                    ensure every aspect of your journey is smooth, enjoyable,
                    and completely worry-free.
                  </p>
                  <p>
                    Thank you for choosing Travasco. We look forward to being
                    part of your next adventure and making it your best one yet.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer></Footer>
    </>
  );
};
export default AboutUs;
